import React from 'react'

export const Informacoes = (props) => {
  return (
    <div>Informacoes</div>
  )
}

